import {
  NotificationsOutlined,
  SettingsOutlined,
  WhatsApp,
} from "@mui/icons-material";
import { Avatar, Badge, IconButton, Sheet, Typography } from "@mui/joy";
import * as React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ColorSchemeToggle } from "../App";
import { getWhatsapp } from "../config/services";
import styles from "./Headermain.module.css";

const HeaderMain = () => {
  const navigate = useNavigate();
  const userInfos = useSelector((state) => state.useInfos);
  const notificationLength = useSelector((state) => state.notification);
  const [whatsapp, setWhatsapp] = React.useState("");

  const str = userInfos.email;
  const firstTwoChars = str.slice(0, 2);

  React.useEffect(() => {
    getWhatsapp().then((data) => {
      if (data != undefined) {
        setWhatsapp(data.number);
        console.log(data.number);
      } else {
        setWhatsapp("");
      }
    });
  }, [notificationLength]);

  return (
    <>
      <Sheet
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          width: "100vw",
          height: "var(--Header-height)",
          zIndex: 9995,
          padding: "5px 10px",
          borderBottom: "1px solid",
          borderColor: "background.level1",
          //  boxShadow: 'sm',
        }}
      >
        <button
          className={styles.userinfo}
          onClick={() => navigate("/profile")}
        >
          <Avatar variant="outlined" size="lg">
            <Typography level="body-lg" textTransform={"uppercase"}>
              {firstTwoChars}
            </Typography>
          </Avatar>
        </button>
        <div className={styles.notificationbuttonParent}>
          
          {whatsapp === "" ? null : (
            <IconButton
              size="md"
              variant="outlined"
              sx={{ borderRadius: 50 }}
              onClick={() => window.open(`https://wa.me/${whatsapp}`, "_blank")}
            >
              <WhatsApp fontSize="xl2" />
            </IconButton>
          )}
          <IconButton
            size="md"
            variant="outlined"
            sx={{ borderRadius: 50 }}
            onClick={() => navigate("/settings")}
          >
            <SettingsOutlined fontSize="xl2" />
          </IconButton>

          <Badge badgeInset={"20%"} badgeContent={notificationLength} size="sm">
            <IconButton
              size="md"
              variant="outlined"
              sx={{ borderRadius: 50 }}
              onClick={() => navigate("/notifications")}
            >
              <NotificationsOutlined fontSize="xl2" />
            </IconButton>
          </Badge>
          <ColorSchemeToggle />
        </div>
      </Sheet>
    </>
  );
};

export default HeaderMain;
